import { defineMessages } from 'react-intl';

export const assignedAppsCountMessages: {
	appsCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	appsCount: {
		id: 'conversation-assistant-content-renderer.assigned-apps-icons.apps-count',
		defaultMessage: '{count, plural, one {# app} other {# apps}}',
		description: 'Label showing number of apps assigned to a prompt',
	},
});
